var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-avatar",
    { attrs: { color: _vm.avatarColor, size: _vm.backgroundSize } },
    [_c("icon-svg", _vm._b({}, "icon-svg", _vm.normalizedIconProps, false))],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }